import { authGuard } from '../services/guards/auth.guard';
import { permissionGuard } from '../services/guards/permission.guard';
import { PermissionValue, ResourceValue } from '../services/permissions/permissions.types';
import { TitleTranslateResolver } from '../services/translate/title-translate.resolver';
import { PortalPath, PortalRoute, RouteItem } from './app.types';
import { TranslateRegistry } from '../services/translate/translate.registry';
import { provideHistoryLogListing } from '../pages/equipment/history-log/listing/history-log-listing.providers';

export const historyLogRoutes: PortalRoute = {
  path: PortalPath.history,
  title: TitleTranslateResolver,
  canMatch: [authGuard, permissionGuard],
  data: {
    hasListingLayout: true,
    routeItem: new RouteItem({
      group: TranslateRegistry.get.MAIN_MENU.SECTION.EQUIPMENT,
      hasRight: {
        resourceValue: ResourceValue.HISTORY_LOG,
        targetPermissionValue: PermissionValue.VIEW
      },
      icon: 'history-log',
      path: PortalPath.history,
      title: TranslateRegistry.get.MAIN_MENU.TITLE.HISTORY_LOG
    }),
    titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.HISTORY_LOG
  },
  loadComponent: () =>
    import('../pages/equipment/history-log/components/history-log-listing-page/history-log-listing-page.component').then(
      c => c.HistoryLogListingPageComponent
    ),
  providers: provideHistoryLogListing()
};
